import { render } from "./Icon.vue.js?vue&type=template&id=465c8215!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Icon.vue?vue&type=template&id=465c8215"
import script from "./Icon.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/Icon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "465c8215"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('465c8215', __exports__)) {
    api.reload('465c8215', __exports__)
  }
  
  module.hot.accept("./Icon.vue.js?vue&type=template&id=465c8215!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Icon.vue?vue&type=template&id=465c8215", () => {
    api.rerender('465c8215', render)
  })

}


export default __exports__